import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgFoa({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 120 35"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="currentColor"
                d="M64.5 22.703c0 1.874-4.34 3.405-8.808 3.397-4.468-.008-8.807-1.523-8.807-3.397V12.46c0-1.873 4.34-3.403 8.807-3.395 4.469.008 8.808 1.522 8.808 3.395v10.244zM75.034 11.98C74.823 7.046 69.633.782 59.217.709 57.262.678 55.692.67 55.692.67S54.123.68 52.17.708C41.752.782 36.562 7.046 36.352 11.98c0 0-.098 1.125-.098 5.474 0 4.176.098 5.496.098 5.496.267 4.998 5.4 11.316 15.827 11.42l3.513.032 3.514-.032c10.427-.104 15.56-6.422 15.828-11.42 0 0 .096-1.32.096-5.496 0-4.35-.096-5.474-.096-5.474M98.849 10.783c3.61 0 5.126 1.067 5.95 5.254 0 0 .565 2.13 1.334 7.102l.003.013h-.003c.77 4.97.848 5.133 1.559 8.974.179.97.394 1.28.737 1.576.914.792 2.085.684 4.864.684 0 0 2.473-.02 3.113-.084.34-.036 3.131-.272 2.502-3.64-1.094-5.853-3.987-19.075-3.987-19.075C113.478 5.113 108.901.615 98.85.6s-14.63 4.514-16.073 10.988c0 0-2.893 13.222-3.987 19.076-.63 3.367 2.162 3.603 2.502 3.639.64.065 3.113.084 3.113.084 2.78 0 3.95.108 4.865-.684.342-.296.557-.606.737-1.576.71-3.84.79-4.004 1.557-8.975l-.002.001.004-.013c.768-4.971 1.333-7.102 1.333-7.102.824-4.187 2.277-5.254 5.95-5.254M16.734.672c-9.79 0-15.422 6.366-15.63 11.323 0 0-.098 1.131-.098 5.502L1 32.392c.004 1.204.634 1.862 1.743 1.908l.01.01s2.639.069 4.245.069c1.56 0 4.659-.072 4.659-.072 1.142-.162 1.696-.758 1.7-2.09 0 0 .003-2.919.003-8.07v-7.715c.223-3.83 1.784-4.645 5.96-4.645h6.04c3.605 0 5.718-.109 5.718-.109 1.071 0 1.657-.591 1.697-1.848l.01-.01-.003-7.242c0-1.255-.676-1.922-1.865-1.922L16.734.664z"
            />
            <path
                fill="currentColor"
                d="M20.29 17.528h-.004c-2.65 0-4.797.785-4.797 2.005v4.574c0 1.22 2.146 2.005 4.797 2.005h.004c2.652 0 4.798-.785 4.798-2.005v-4.574c0-1.22-2.146-2.005-4.798-2.005M98.91 17.653h-.004c-2.651 0-4.74.785-4.74 2.005l-.057 4.326c0 1.222 2.146 2.007 4.797 2.007h.005c2.651 0 4.796-.785 4.796-2.007l-.102-4.239c0-1.22-2.043-2.092-4.694-2.092"
            />
        </svg>
    )
}
SvgFoa.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgFoa
